// extracted by mini-css-extract-plugin
module.exports = {"container":"no-reviews_container__udPq8","header":"no-reviews_header__Mo6Ur","body":"no-reviews_body__NiM42","icon":"no-reviews_icon__2qkC8"};